import { useState as n, useCallback as a, useLayoutEffect as d } from "react";
var A = /* @__PURE__ */ ((r) => (r.BACK = "BACK", r.FORWARD = "FORWARD", r))(A || {});
const i = (r) => {
  const [l, u] = n({
    back: !1,
    forward: !1
  }), e = a(() => {
    if (!r.current)
      return;
    const { scrollLeft: t, offsetWidth: s, scrollWidth: o } = r.current;
    u({
      back: t !== 0,
      forward: t + s < o
    });
  }, [r]);
  return d(() => {
    e();
  }, []), {
    arrowsNavigation: l,
    updateNavigators: e,
    scroll: (t, s) => {
      if (s && s(), !r.current)
        return;
      const { scrollLeft: o, offsetWidth: c } = r.current, f = t === "FORWARD" ? o + c * 0.8 : o - c * 0.8;
      r.current.scroll({
        left: f,
        behavior: "smooth"
      });
    }
  };
};
export {
  A as ScrollNavigation,
  i as useScrollNavigation
};
